import {useNavigate, useParams} from "react-router-dom";
import {Alert, Card, CardContent, CircularProgress, Typography} from "@mui/material";
import SnackError from "../../components/SnackError";
import React from "react";
import {MachineApiPut, useGetMachineByIdQuery, usePutMachineByIdMutation} from "./machine_api";
import MachineForm from "./MachineForm";
import {useGetOperationQuery} from "../operation/operation_api";


export const MachineEdit = () => {

    const {id} = useParams<"id">()
    const {data, isFetching} = useGetMachineByIdQuery({id: parseInt(id || ""), select: "*,workTask(*)"});
    const {data: workTasks} = useGetOperationQuery({})
    const [put, {
        isLoading: isUpdating,
        error,
        isError,
    }] = usePutMachineByIdMutation();
    const navigate = useNavigate();
    const params = useParams<"id">();

    const handleSubmit = async function (values: MachineApiPut) {
        const res = await put({
            id: parseInt(params.id || ""),
            body: {
                Code: values.Code,
                Name: values.Name,
                Active: values.Active,
                DefaultOperationID: values.workTask?.id || null
            }
        })
        if ("data" in res) {
            navigate("..", {replace: true})
        }
    };
    if (!data || isFetching)
        return <CircularProgress/>;

    if (!data) return <Alert severity={"error"}>Not found</Alert>

    return <Card sx={{mt: "2em"}}>
        <CardContent>
            <Typography variant={"h1"}>{data && data.Name}</Typography>
        </CardContent>
        {isError && <SnackError error={error}/>}
        <MachineForm
            isUpdating={isUpdating}
            onSubmit={handleSubmit}
            workTasks={workTasks}
            onCancel={() => navigate("..", {replace: true})}
            object={data}
        />
    </Card>;
}
